<template>
  <div class="wrap">
    <div class="left">
      <DayPilotNavigator
          ref="navigator"
          :showMonths="3"
          :skipMonths="1"
          selectMode="Day"
          :startDate="initialNavigatorDate"
          :selectionDay="selectDate"
          :events="events"
          @timeRangeSelected="onNavTimeRangeSelected"
		  :config="navigatorConfig"
      />
    </div>
    <div class="content">
      <DayPilotCalendar
          ref="calendar"
          viewType="Resources"
          :events="events"
          :columns="columns"
          :startDate="selectDate"
          timeRangeSelectedHandling="Enabled"
          eventDeleteHandling="Disabled"
          :eventBorderRadius="4"
          @beforeEventRender="onBeforeEventRender"
          @timeRangeSelected="onCalTimeRangeSelected"
          @eventClick="onEventClick"
          @eventMoved="onEventMoved"
          @eventResized="onEventResized"
      />
    </div>
  </div>
</template>

<script setup>
	import { ref, onMounted,watch,inject } from "vue"
	import axios from 'axios';
	import { DayPilot, DayPilotCalendar, DayPilotNavigator } from "@daypilot/daypilot-lite-vue"
	import { useMemberStore } from '@/stores';
	import { ElMessage } from 'element-plus'
	import JSONbig from "json-bigint";
	const userStore = useMemberStore();
	
	const billid = inject('billid');//订单数据id
	const order_id = inject('order_id')//订单号
	const src = inject('src') //订单来源
	const ydsj = inject("ydsj")//预订时间 日期
	const dayTableData = inject("dayTableData")
	
	const checkedCitiesZt = ref(['已确认'])
	const loadTableData = async() =>{
		const response = await axios.post('/orders/info/queryHighsearch', {
		  syjssj:selectDate.value + " 23:59:59",
		  sykssj:selectDate.value + " 00:00:01",
		  ddzt:checkedCitiesZt.value.toString(),
		  pageNo:1,
		  pageSize:100,
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			dayTableData.value = response.data.data;
		}
	}
	
	const navigatorConfig = ref({
		onVisibleRangeChanged:args=>{
			startDate.value = args.start.value
			endDate.value = args.end.value
			loadResources()
			loadEvents()
		}
	})
	
	const calendar = ref(null)
	const navigator = ref(null)

	const initialNavigatorDate = ref('')
	const startDate = ref("2025-12-01")
	const selectDate = ref('')
	const endDate = ref("2030-12-31")

	const events = ref([])
	const columns = ref([])
	
	const onNavTimeRangeSelected = (args) => {
		selectDate.value = args.day.value?.substring(0,10)
		initialNavigatorDate.value = args.day
		loadTableData();
	}

	const onCalTimeRangeSelected = async (args) => {
	  await createEvent(args.start, args.end, args.resource)
	  calendar.value.control.clearSelection()
	}

	const onEventClick = (args) => {
	  editEvent(args.e)
	}
	const onEventMoved = async(args) => {
	  const eData = args.e.data
	  //开始更新司机订单数据 update,order_no必须传
	  const respDriver = await axios.post('/orders/info/assignDriver',{
	  	order_no:order_id.value,
	  	update:'1',
	  	driver_id:carDefaultDriverID.value[`${eData.resource}`],
	  	vehicle_id:eData.resource,
		startDate:eData.start.value,
		endDate:eData.end.value
	  },{
	    headers: {
	      'Content-Type': 'application/json',
	  	Authorization: `${userStore.profile?.token}`,
	    }
	  });
	  if(respDriver.data.status===0){
	  	ElMessage({
	  		message: '车辆分配成功!',
	  		type: 'success',
	  	})
	  }else{
	  	ElMessage.error('哦,车辆分配失败了!')
	  }
	}
	const onEventResized = (args) => {
	  console.log("Event resized", args.e)
	}

	const onBeforeEventRender = (args) => {
	  if (!args.data.backColor) {
		args.data.backColor = "#bbbbbb"
	  }
	  args.data.borderColor = "darker"
	  args.data.html = ""
	  args.data.barHidden = true
	  args.data.areas = [
		{
		  left: 4,
		  height: 24,
		  top: 4,
		  right: 4,
		  html: args.data.orderID,
		  padding: 2,
		  horizontalAlignment: "center",
		  backColor: "#fff",
		  style: "opacity: 0.5"
		}
	  ]
	}

	const loadEvents = async() => {
		events.value = [];
		const response = await axios.post('/klook/car/getDriverOrderList', {
			startDate:startDate.value,
			endDate:endDate.value
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			const orders = response.data.data
			if(orders){
				orders.map(item=>{
					events.value.push({ 
						id: `${item.id}`, 
						start: `${item.start_date}`, 
						end: `${item.end_date}`, 
						resource: `${item.carid}`, 
						orderID: `${item.order_no}`, 
						backColor: `${item.background_color}`
					})
				})
				
			}
		}
	}
	//加载车辆资源  司机资源  现在默认是使用默认司机
	const carDefaultDriverID = ref({})
	const loadResources = async() => {
		columns.value = []
		const response = await axios.post('/klook/car/getList', {}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			const cars = JSONbig.parse(response.data.data)
			if(cars){
				cars.map(item=>{
					columns.value.push({
						name:`${item.plate_number}`,id:`${item.id}`
					})
					carDefaultDriverID.value[`${item.id}`] = `${item.default_driver}`
				})
			}
		}
	}

	const editEvent = async (e) => {
	  const form = [
		{ name: "订单号", id: "orderID", disabled: true },
		{ name: "背景色", id: "backColor", disabled: true },
		{ name: "开始时间", id: "start", type: "datetime", disabled: true },
		{ name: "结束时间", id: "end", type: "datetime", disabled: false },
		{ name: "安排车辆", id: "resource", type: "select", options: calendar.value.control.columns.list },
	  ]
	  const data = e.data
	  const modal = await DayPilot.Modal.form(form, data,
	  {
		okText: "确定",
		cancelText: "取消",
	  })
	  
	  if (modal.canceled) {
		return
	  }
	  const eData = modal.result
	  calendar.value.control.events.update(modal.result)
	  //开始更新司机订单数据 update,order_no必须传
	  const respDriver = await axios.post('/orders/info/assignDriver',{
	  	order_no:order_id.value,
	  	update:'1',
	  	driver_id:carDefaultDriverID.value[`${eData.resource}`],
	  	vehicle_id:eData.resource,
		startDate:eData.start.value,
		endDate:eData.end.value
	  },{
	    headers: {
	      'Content-Type': 'application/json',
	  	Authorization: `${userStore.profile?.token}`,
	    }
	  });
	  if(respDriver.data.status===0){
	  	ElMessage({
	  		message: '车辆分配成功!',
	  		type: 'success',
	  	})
	  }else{
	  	ElMessage.error('哦,车辆分配失败了!')
	  }
	}

	const createEvent = async (start, end, resource) => {
		const res = await axios.post('/orderSjdd/queryList',{
			key:'a.order_no',
			pageNo:1,
			pageSize:10,
			value:order_id.value
		},{
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(res.data.status===0&&res.data.data.length>0){
			ElMessage.error('哦,这个订单已分配车辆!')
			return;
		}
	  const form = [
		{ name: "订单号", id: "orderID", disabled: true },
		{ name: "背景色", id: "backColor", disabled: true },
		{ name: "开始时间", id: "start", type: "datetime", disabled: true },
		{ name: "结束时间", id: "end", type: "datetime", disabled: false },
		{ name: "安排车辆", id: "resource", type: "select", options: calendar.value.control.columns.list },
	  ]
	  //把order_id默认带过来
	  const data = { start, end, resource, id: DayPilot.guid(),orderID:order_id.value,backColor:'#' + Math.floor(Math.random() * 0xffffff).toString(16).padStart(6, '0') }
	  const modal = await DayPilot.Modal.form(form, data,
	  {
		okText: "确定",
		cancelText: "取消"
	  })
	  if (modal.canceled) {
		return
	  }

	  const e = modal.result
	  calendar.value.control.events.add(e)
	  //开始插入司机订单数据
	  const respDriver = await axios.post('/orders/info/assignDriver',{
	  	billid:billid.value,
	  	src:src.value,
	  	driver_id:carDefaultDriverID.value[`${e.resource}`],
	  	vehicle_id:e.resource,
		startDate:e.start.value,
		endDate:e.end.value,
		backColor:e.backColor
	  },{
	    headers: {
	      'Content-Type': 'application/json',
	  	Authorization: `${userStore.profile?.token}`,
	    }
	  });
	  if(respDriver.data.status===0){
	  	ElMessage({
	  		message: '车辆分配成功!',
	  		type: 'success',
	  	})
	  }else{
	  	ElMessage.error('哦,车辆分配失败了!')
	  }
	}
	onMounted(() => {
		const now = new Date()
		const cy = now.getFullYear()
		const cm = String(now.getMonth() + 1).padStart(2, "0")
		const cd = String(now.getDate()).padStart(2, "0")
		const firstDay = new Date(now.getFullYear(), now.getMonth()-2, 1)
		const y = firstDay.getFullYear()
		const m = String(firstDay.getMonth() + 1).padStart(2, "0")
		const d = String(firstDay.getDate()).padStart(2, "0")
		const lastDay = new Date(now.getFullYear(), now.getMonth() + 2, 30)
		const ly = lastDay.getFullYear()
		const lm = String(lastDay.getMonth() + 1).padStart(2, "0")
		const ld = String(lastDay.getDate()).padStart(2, "0")
		selectDate.value = ydsj.value.substring(0,10)
		initialNavigatorDate.value = ydsj.value.substring(0,10)
		startDate.value = `${y}-${m}-${d}` //当月第一天
		endDate.value = `${ly}-${lm}-${ld}` //当月最后一天
		loadResources()
		loadTableData();
	})
	watch(
	  () => order_id.value,
	  () => {
		selectDate.value = ydsj.value.substring(0,10)
		loadEvents()
	  },
	  { immediate: true }
	)
</script>

<style>
	.wrap {
	  display: flex;
	}
	.left {
	  margin-right: 10px;
	}
	.content {
	  flex-grow: 1;
	}
	.calendar_default_main{
		height: 720px;
	}
	.calendar_default_main > div:nth-child(2) {
	  height: 690px!important;      /* 你想要的高度 */
	}
	.navigator_default_busy.navigator_default_cell {
	  border-bottom: 4px solid #ee4f2ecc;
	  box-sizing: border-box;
	}
	.calendar_default_event > div:nth-child(2) {
	  opacity: 1 !important;
	}
</style>